module.exports = __webpack_public_path__ + "img/logo.8c4120b4.png";